const manutencao_da_estrutura_curricular_para_supletivo = [
  {
    path: "/estrutura_curricular_para_supletivo",
    redirect: "",
    component: () => import("@/layout/Layout.vue"),
    meta: {
      breadCrumb: "Informações Acadêmicas - Manutenção de Histórico",
      allowedPermissions: ["estrutura_curricular_supletivo_show"],
    },
    children: [
      {
        path: "/manutencao-da-estrutura-curricular-para-supletivo",
        name: "manutencao_da_estrutura_curricular_para_supletivo",
        component: () =>
          import(
            "@/views/ManutecaoDaEstruturaCurricularParaSupletivo/ManutencaoDaEstruturaCurricularParaSupletivoHome.vue"
          ),
        meta: {
          allowedPermissions: ["estrutura_curricular_supletivo_list"],
        },
      },
      {
        path: "/cadastrar-manutencao-da-estrutura-curricular-para-supletivo",
        name: "cadastrar_manutencao_da_estrutura_curricular_para_supletivo",
        component: () =>
          import(
            "@/views/ManutecaoDaEstruturaCurricularParaSupletivo/ManutencaoDaEstruturaCurricularParaSupletivoCad.vue"
          ),
        meta: {
          allowedPermissions: ["estrutura_curricular_supletivo_create"],
        },
      },
      {
        path: "editar-manutencao-da-estrutura-curricular-para-supletivo/:id",
        name: "editar_manutencao_da_estrutura_curricular_para_supletivo",
        component: () =>
          import(
            "@/views/ManutecaoDaEstruturaCurricularParaSupletivo/ManutencaoDaEstruturaCurricularParaSupletivoEdit.vue"
          ),
        props: (route) => ({ isEdit: route.query.isEdit }),
        meta: {
          allowedPermissions: ["estrutura_curricular_supletivo_edit"],
        },
      },
    ],
  },
];

export { manutencao_da_estrutura_curricular_para_supletivo };
